import client from "../../client";
import { AssetActionTypeInterface } from "../../../models/AssetModel/AssetAction/AssetActionType";

class AssetActionTypeService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/AssetActionTypes`;
      if (page > 0 && pageSize > 0) {
        url += `?page=${page}&pageSize=${pageSize}`;
      }
      const { data } = await client.get<AssetActionTypeInterface[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/AssetActionTypes/getbyid/${id}`;

      const { data } = await client.get<AssetActionTypeInterface>(url);

      return data;
    } catch (error) {
      throw error;
    }
  }

  async Save(customer: AssetActionTypeInterface) {
    try {
      let url = `/api/AssetActionTypes`;

      const { data } = await client.post<AssetActionTypeInterface>(
        url,
        customer
      );

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, customer: AssetActionTypeInterface) {
    try {
      let url = `/api/AssetActionTypes/update/${id}`;

      const { data } = await client.post<AssetActionTypeInterface>(
        url,
        customer
      );

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/AssetActionTypes/remove/${id}`;
      await client.post<AssetActionTypeInterface>(url, { url: "" });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new AssetActionTypeService();
